import { useState } from 'react';

export default function Gallery() {
  const [lightboxImage, setLightboxImage] = useState<string | null>(null);

  const images = [
    {
      src: 'https://public.readdy.ai/ai/img_res/675078ea1a6462dd95a422f12bfdc846.jpg',
      alt: 'Lighthouse at sunset',
      height: 'h-[500px]'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=elegant%20sailboat%20gliding%20peacefully%20on%20calm%20turquoise%20ocean%20waters%20under%20clear%20blue%20sky%2C%20serene%20and%20tranquil%20scene%2C%20professional%20photography%2C%20therapeutic%20calming%20atmosphere%2C%20simple%20clean%20composition&width=600&height=400&seq=gallery-sailboat-001&orientation=landscape',
      alt: 'Sailboat on calm waters',
      height: 'h-[300px]'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=peaceful%20coastal%20therapy%20office%20interior%20with%20large%20windows%20overlooking%20ocean%2C%20comfortable%20seating%2C%20warm%20natural%20lighting%2C%20plants%2C%20calming%20neutral%20colors%2C%20professional%20therapeutic%20space%2C%20welcoming%20atmosphere&width=600&height=700&seq=gallery-office-001&orientation=portrait',
      alt: 'Therapy office with ocean view',
      height: 'h-[450px]'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=serene%20shoreline%20with%20gentle%20waves%20washing%20onto%20sandy%20beach%2C%20soft%20morning%20light%2C%20peaceful%20coastal%20scene%2C%20therapeutic%20calming%20atmosphere%2C%20professional%20landscape%20photography%2C%20simple%20clean%20composition&width=600&height=400&seq=gallery-shoreline-001&orientation=landscape',
      alt: 'Peaceful shoreline',
      height: 'h-[320px]'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=cozy%20meditation%20room%20in%20coastal%20therapy%20practice%20with%20ocean%20view%2C%20comfortable%20cushions%2C%20soft%20lighting%2C%20peaceful%20atmosphere%2C%20plants%2C%20calming%20neutral%20tones%2C%20professional%20therapeutic%20space&width=600&height=600&seq=gallery-meditation-001&orientation=squarish',
      alt: 'Meditation space',
      height: 'h-[400px]'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=beautiful%20coastal%20lighthouse%20illuminated%20at%20golden%20hour%20with%20warm%20glowing%20light%2C%20dramatic%20sky%20with%20soft%20clouds%2C%20peaceful%20ocean%20in%20background%2C%20professional%20photography%2C%20serene%20therapeutic%20mood&width=600&height=700&seq=gallery-lighthouse-002&orientation=portrait',
      alt: 'Lighthouse at golden hour',
      height: 'h-[480px]'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=comfortable%20therapy%20consultation%20room%20with%20large%20windows%2C%20ocean%20view%2C%20modern%20furniture%2C%20warm%20lighting%2C%20plants%2C%20calming%20colors%2C%20professional%20therapeutic%20environment%2C%20welcoming%20atmosphere&width=600&height=500&seq=gallery-consultation-001&orientation=landscape',
      alt: 'Consultation room',
      height: 'h-[360px]'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=multiple%20sailboats%20sailing%20peacefully%20on%20calm%20blue%20ocean%20waters%20at%20sunset%2C%20serene%20coastal%20scene%2C%20therapeutic%20calming%20atmosphere%2C%20professional%20photography%2C%20beautiful%20sky%20colors%2C%20peaceful%20mood&width=600&height=600&seq=gallery-sailboats-002&orientation=squarish',
      alt: 'Sailboats at sunset',
      height: 'h-[400px]'
    }
  ];

  return (
    <>
      <section id="gallery" className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <span className="text-[#2C5F7C] text-sm font-semibold tracking-wider uppercase" style={{ fontFamily: 'Inter, sans-serif' }}>
              Our Environment
            </span>
            <h2 className="text-5xl font-bold text-gray-900 mt-4" style={{ fontFamily: 'Playfair Display, serif' }}>
              A Space for Healing
            </h2>
          </div>

          <div className="grid grid-cols-4 gap-3">
            {images.map((image, index) => (
              <div
                key={index}
                className={`${image.height} overflow-hidden rounded-xl cursor-pointer group`}
                onClick={() => setLightboxImage(image.src)}
              >
                <img
                  src={image.src}
                  alt={image.alt}
                  className="w-full h-full object-cover transition-all duration-500 group-hover:scale-105 group-hover:grayscale-0 grayscale-[20%]"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {lightboxImage && (
        <div
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-8 cursor-pointer"
          onClick={() => setLightboxImage(null)}
        >
          <button
            className="absolute top-6 right-6 text-white text-4xl hover:text-gray-300 transition-colors w-12 h-12 flex items-center justify-center cursor-pointer"
            onClick={() => setLightboxImage(null)}
          >
            <i className="ri-close-line"></i>
          </button>
          <img
            src={lightboxImage}
            alt="Gallery image"
            className="max-w-full max-h-full object-contain rounded-lg"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </>
  );
}
